import Dataspaces from "./views/Dataspaces.vue";

const moduleRoutes = [
	{
		path: "/:domainId/template/dataspaces",
		name: "Dataspaces",
		component: Dataspaces,
	},
];

export default moduleRoutes;
